<template>
  <div class="xjsrdzd-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <!-- 搜索条件 -->
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="收款日期">
              <el-date-picker
                v-model="searchForm.time"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd"
                type="daterange"
                style="width:300px"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              />
            </el-form-item>
            <el-form-item label="收款类型">
              <el-select v-model="searchForm.type" style="width: 130px" clearable>
                <el-option :label="typeList[0]" :value="0" />
                <el-option :label="typeList[3]" :value="3" />
                <el-option :label="typeList[5]" :value="5" />
                <el-option :label="typeList[6]" :value="6" />
                <el-option :label="typeList[66]" :value="66" />
                <el-option :label="typeList[7]" :value="7" />
                <el-option :label="typeList[8]" :value="8" />
              </el-select>
            </el-form-item>
            <el-form-item label="收款内容">
              <el-select v-model="searchForm.paycontent" style="width: 130px" clearable>
                <el-option
                  v-for="item in paycontentList"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name"
                />
              </el-select>
            </el-form-item>
            <br>
            <el-form-item label="操作日期">
              <el-date-picker
                v-model="searchForm.opertime"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd"
                type="daterange"
                style="width:300px"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              />
            </el-form-item>
            <el-form-item label="关键字">
              <el-input v-model="searchForm.search" style="width:200px" placeholder="关键字搜索" @keyup.enter.native="Search" />
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search()">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-printer" :loading="pringLoading" @click="print">打印对账单</el-button>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-printer" :loading="excelLoading" @click="exportExcel">导出Excel</el-button>
            </el-form-item>
          </el-form>
          <!-- 表格内容 -->
          <div class="card-content">
            <el-table
              v-loading="loading"
              :data="tableData"
              stripe
              :row-style="{cursor: 'pointer'}"
              style="width: 100%"
              @row-click="openDetails"
            >
              <el-table-column
                label="收款类型"
                width="100"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ typeList[scope.row.collectionType] }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="经销商"
                width="100"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.dealerName }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column
                label="经销商电话"
                width="110"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.dealerTel }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="经销商区域"
                width="160"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.province+scope.row.city+scope.row.county }}</span>
                </template>
              </el-table-column> -->
              <el-table-column
                label="收款内容"
                width="100"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.content }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="订单类型"
                width="80"
                header-align="center"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ orderTypeList[scope.row.orderType] }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="订单号"
                width="110"
                header-align="center"
                align="left"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.orderNum }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="订单状态"
                width="100"
                header-align="center"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ orderStatusList[scope.row.orderStatus] }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="生产单号"
                width="80"
                header-align="center"
                align="left"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.produnum }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="终端地址"
                width="200"
                header-align="center"
                align="left"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.address }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column
                label="订单信息"
                width="360"
                header-align="center"
                align="left"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>
                    <span style="color:#99a9bf">订单信息：</span>
                    <span>{{ scope.row.orderNum }}/{{ scope.row.produnum }}，{{ scope.row.address }}</span>
                  </span>
                </template>
              </el-table-column> -->
              <el-table-column
                label="总金额"
                width="80"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.totalamount }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="折扣"
                width="60"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.discount>0" :disable-transitions="true" size="mini" type="danger">{{ scope.row.discount }}折</el-tag>
                  <el-tag v-if="scope.row.discount<=0" :disable-transitions="true" size="mini" type="info">0折</el-tag>
                </template>
              </el-table-column>
              <el-table-column
                label="客户承担"
                width="80"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.clientcom }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="工厂承担"
                width="80"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.factorycom }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="设计承担"
                width="80"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.designcom }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="已支付金额"
                width="100"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.paidfor }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="待支付金额"
                width="100"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.leftMoney }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="备注"
                width="120"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.remark }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="操作时间"
                width="180"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.crTime }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="收款金额"
                width="100"
                align="center"
                fixed="right"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span style="color:#409EFF;font-weight: 500;">{{ scope.row.money }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="收款时间"
                width="100"
                align="center"
                fixed="right"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.receiptTime }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="负责人"
                width="100"
                align="center"
                fixed="right"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.operName }}</span>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              v-if="total>0"
              background
              :current-page="currentPage"
              :page-sizes="[20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- 账户抵扣明细 -->
    <el-dialog
      title="账户抵扣明细"
      :visible.sync="collectRecordVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <table class="tcf-detail-table">
        <tr>
          <th>经销商</th>
          <td>{{ collectRecordData.dealerName }}</td>
          <th>操作人</th>
          <td>{{ collectRecordData.operName }}</td>
          <th>操作时间</th>
          <td colspan="3">{{ collectRecordData.crTime }}</td>
        </tr>
        <tr>
          <th>订单号</th>
          <td><el-button type="text" size="mini" icon="el-icon-document" @click="goOrder(collectRecordData.orderid)">{{ collectRecordData.orderNum }}</el-button></td>
          <th>生产单号</th>
          <td>{{ collectRecordData.produnum }}</td>
          <th>终端地址</th>
          <td>{{ collectRecordData.address }}</td>
        </tr>
        <tr>
          <th>收款日期</th>
          <td>{{ collectRecordData.receiptTime }}</td>
          <th>收款金额</th>
          <td style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" /> {{ collectRecordData.money }}</td>
          <th>总金额</th>
          <td style="font-weight: 500;">
            <i class="el-icon-coin" />
            <span style="margin-right: 6px">{{ collectRecordData.totalamount }}</span>
            <el-tag v-if="collectRecordData.discount>0" :disable-transitions="true" size="mini" type="danger">{{ collectRecordData.discount }}折</el-tag>
            <el-tag v-if="collectRecordData.discount<=0" :disable-transitions="true" size="mini" type="info">0折</el-tag>
          </td>
        </tr>
        <tr>
          <th>收款性质</th>
          <td>
            <span>{{ typeList[collectRecordData.collectionType] }}</span>
          </td>
          <th>收款内容</th>
          <td colspan="3">{{ collectRecordData.content }}</td>
        </tr>
        <tr>
          <th>备注</th>
          <td colspan="5">{{ collectRecordData.remark }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="collectRecordVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 对公打款详情 -->
    <el-dialog
      title="收款审核"
      :visible.sync="editVisible"
      width="700px"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <table v-loading="fullscreenLoading" class="tcf-detail-table">
        <tr>
          <th>申请人</th>
          <td>{{ editForm.applyname }}</td>
          <th>申请时间</th>
          <td colspan="3">{{ eidtList.ra.time }}</td>
        </tr>
        <tr>
          <th>审核人</th>
          <td>{{ eidtList.ra.auditname }}</td>
          <th>审核时间</th>
          <td colspan="3">{{ eidtList.ra.audittime }}</td>
        </tr>
        <tr>
          <th>流水号</th>
          <td colspan="5">{{ eidtList.ra.ranum }}</td>
        </tr>
        <tr>
          <th>经销商</th>
          <td>{{ editForm.delname }}</td>
          <th>卡号</th>
          <td colspan="3">{{ eidtList.ra.card }}</td>
        </tr>
        <tr>
          <th>打款账户</th>
          <td colspan="3">
            <span v-for="av in eidtList.accountList" v-if="av.is_select===1" :key="av.card">{{ av.account_name }}（{{ av.card }}）</span>
            <span v-if="eidtList.oldaccount!==null&&eidtList.oldaccount!==''&&eidtList.oldaccount!==undefined">{{ eidtList.oldaccount }}</span>
          </td>
          <th>打款日期</th>
          <td>{{ eidtList.ra.receipttime }}</td>
        </tr>
        <tr>
          <th>打款内容</th>
          <td>{{ eidtList.ra.paycontent }}</td>
          <th>打款金额</th>
          <td colspan="3" style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" /> {{ eidtList.ra.money }}</td>
        </tr>
        <tr>
          <th>打款凭证</th>
          <td colspan="5">
            <el-image
              v-for="iurl in imgSrcList"
              :key="iurl"
              style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
              :src="iurl"
              :preview-src-list="imgSrcList"
            />
          </td>
        </tr>
        <tr>
          <th>打款备注</th>
          <td colspan="5">{{ eidtList.ra.remark }}</td>
        </tr>
        <tr>
          <th>经销商</th>
          <td>{{ collectRecordData.dealerName }}</td>
          <th>操作人</th>
          <td>{{ collectRecordData.operName }}</td>
          <th>操作时间</th>
          <td colspan="3">{{ collectRecordData.crTime }}</td>
        </tr>
        <tr>
          <th>订单号</th>
          <td><el-button type="text" size="mini" icon="el-icon-document" @click="goOrder(collectRecordData.orderid)">{{ collectRecordData.orderNum }}</el-button></td>
          <th>生产单号</th>
          <td>{{ collectRecordData.produnum }}</td>
          <th>终端地址</th>
          <td>{{ collectRecordData.address }}</td>
        </tr>
        <tr>
          <th>抵款日期</th>
          <td>{{ collectRecordData.receiptTime }}</td>
          <th>抵款金额</th>
          <td>
            <span style="color:#409EFF;font-weight: 500;margin-right: 6px;"><i class="el-icon-coin" /> {{ collectRecordData.money }}</span>
            <el-tag :disable-transitions="true" size="mini" type="danger">{{ creditPercentage }}%</el-tag>
          </td>
          <th>总金额</th>
          <td>
            <span style="margin-right: 6px;font-weight: 500;"><i class="el-icon-coin" /> {{ collectRecordData.totalamount }}</span>
            <el-tag v-if="collectRecordData.discount>0" :disable-transitions="true" size="mini" type="danger">{{ collectRecordData.discount }}折</el-tag>
            <el-tag v-if="collectRecordData.discount<=0" :disable-transitions="true" size="mini" type="info">0折</el-tag>
          </td>
        </tr>
        <tr>
          <th>收款性质</th>
          <td>
            <span>{{ typeList[collectRecordData.collectionType] }}</span>
          </td>
          <th>收款内容</th>
          <td colspan="3">{{ collectRecordData.content }}</td>
        </tr>
        <tr>
          <th>备注</th>
          <td colspan="5">{{ collectRecordData.remark }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="editVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 返点抵扣详情 -->
    <el-dialog
      title="返点抵扣详情"
      :visible.sync="viewRebateVisible"
      width="50%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <table v-loading="viewRebateLoading" class="tcf-detail-table">
        <tr>
          <th>审核人</th>
          <td>{{ viewRebatedata.auditname }}</td>
          <th>审核时间</th>
          <td colspan="3">{{ viewRebatedata.audittime }}</td>
        </tr>
        <tr>
          <th>返点名称</th>
          <td colspan="5" style="color:#000;">{{ viewRebatedata.name }}</td>
        </tr>
        <tr>
          <th>有效期</th>
          <td colspan="5">
            <span v-if="viewRebatedata.starttime==='0'"><i class="el-icon-date" /> 无期限</span>
            <span v-if="viewRebatedata.starttime!=='0'"><i class="el-icon-date" /> {{ viewRebatedata.starttime }} ~ {{ viewRebatedata.endtime }}</span>
            /
            <span>订单金额满 {{ viewRebatedata.orderMoney }} 元以上可享受，同比享受最低折扣不低于 {{ viewRebatedata.mindiscount }} 折</span>
          </td>
        </tr>
        <tr>
          <th>返点总额</th>
          <td style="font-weight: 500;"><i class="el-icon-coin" /> {{ viewRebatedata.amount }}</td>
          <!--          <th>返点余额</th>-->
          <!--          <td style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin"></i> {{ viewRebatedata.balance }}</td>-->
          <th>抵款方式</th>
          <td>
            <span v-if="viewRebatedata.credit===0">最高冲抵{{ viewRebatedata.maximpact }}%</span>
            <span v-if="viewRebatedata.credit===1">享受{{ viewRebatedata.maxdiscount }}折</span>
            <span v-if="viewRebatedata.credit===9">任意冲抵</span>
          </td>
          <th>适用订单</th>
          <td>
            <span v-if="viewRebatedata.ordertype===0">无限制</span>
            <span v-if="viewRebatedata.ordertype===1">正单</span>
            <span v-if="viewRebatedata.ordertype===2">补单</span>
          </td>
        </tr>
        <tr>
          <th>返点凭证</th>
          <td colspan="5">
            <el-image
              v-for="iurl in imgRebateSrcList"
              :key="iurl"
              style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
              :src="iurl"
              :preview-src-list="imgRebateSrcList"
            />
          </td>
        </tr>
        <tr>
          <th>返点说明</th>
          <td colspan="5">{{ viewRebatedata.remark }}</td>
        </tr>
        <tr>
          <th>经销商</th>
          <td>{{ collectRecordData.dealerName }}</td>
          <th>操作人</th>
          <td>{{ collectRecordData.operName }}</td>
          <th>操作时间</th>
          <td colspan="3">{{ collectRecordData.crTime }}</td>
        </tr>
        <tr>
          <th>订单号</th>
          <td><el-button type="text" size="mini" icon="el-icon-document" @click="goOrder(collectRecordData.orderid)">{{ collectRecordData.orderNum }}</el-button></td>
          <th>生产单号</th>
          <td>{{ collectRecordData.produnum }}</td>
          <th>终端地址</th>
          <td>{{ collectRecordData.address }}</td>
        </tr>
        <tr>
          <th>抵款日期</th>
          <td>{{ collectRecordData.receiptTime }}</td>
          <th>抵款金额</th>
          <td>
            <span style="color:#409EFF;font-weight: 500;margin-right: 6px;"><i class="el-icon-coin" /> {{ collectRecordData.money }}</span>
            <el-tag :disable-transitions="true" size="mini" type="danger">{{ creditPercentage }}%</el-tag>
          </td>
          <th>总金额</th>
          <td>
            <span style="margin-right: 6px;font-weight: 500;"><i class="el-icon-coin" /> {{ collectRecordData.totalamount }}</span>
            <el-tag v-if="collectRecordData.discount>0" :disable-transitions="true" size="mini" type="danger">{{ collectRecordData.discount }}折</el-tag>
            <el-tag v-if="collectRecordData.discount<=0" :disable-transitions="true" size="mini" type="info">0折</el-tag>
          </td>
        </tr>
        <tr>
          <th>收款性质</th>
          <td>
            <span>{{ typeList[collectRecordData.collectionType] }}</span>
          </td>
          <th>收款内容</th>
          <td colspan="3">{{ collectRecordData.content }}</td>
        </tr>
        <tr>
          <th>备注</th>
          <td colspan="5">{{ collectRecordData.remark }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="viewRebateVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 赔款/划账抵扣详情 -->
    <el-dialog
      :title="collectRecordData.collectionType==6?'赔款抵扣详情':'划账抵扣详情'"
      :visible.sync="viewAfterVisible"
      width="50%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <table v-loading="viewAfterLoading" class="tcf-detail-table">
        <tr>
          <th>审核人</th>
          <td>{{ viewAfterdata.auditname }}</td>
          <th>审核时间</th>
          <td colspan="3">{{ viewAfterdata.audittime }}</td>
        </tr>
        <tr>
          <th>赔款名称</th>
          <td colspan="2" style="color:#000;">{{ viewAfterdata.name }}</td>
          <td colspan="3">
            订单金额满 {{ viewAfterdata.orderMoney }} 元以上可冲抵
          </td>
        </tr>
        <tr>
          <th>赔款总额</th>
          <td style="font-weight: 500;"><i class="el-icon-coin" /> {{ viewAfterdata.amount }}</td>
          <!--          <th>账户余额</th>-->
          <!--          <td style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin"></i> {{ viewAfterdata.balance }}</td>-->
          <th>抵款方式</th>
          <td>
            <span v-if="viewAfterdata.credit===0">最高冲抵{{ viewAfterdata.maximpact }}%</span>
            <span v-if="viewAfterdata.credit===9">任意冲抵</span>
          </td>
          <th>适用订单</th>
          <td>
            <span v-if="viewAfterdata.ordertype===0">无限制</span>
            <span v-if="viewAfterdata.ordertype===1">正单</span>
            <span v-if="viewAfterdata.ordertype===2">补单</span>
          </td>
        </tr>
        <tr>
          <th>赔款凭证</th>
          <td colspan="5">
            <el-image
              v-for="iurl in imgAfterSrcList"
              :key="iurl"
              style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
              :src="iurl"
              :preview-src-list="imgAfterSrcList"
            />
          </td>
        </tr>
        <tr>
          <th>赔款说明</th>
          <td colspan="5">{{ viewAfterdata.remark }}</td>
        </tr>
        <tr>
          <th>经销商</th>
          <td>{{ collectRecordData.dealerName }}</td>
          <th>操作人</th>
          <td>{{ collectRecordData.operName }}</td>
          <th>操作时间</th>
          <td colspan="3">{{ collectRecordData.crTime }}</td>
        </tr>
        <tr>
          <th>订单号</th>
          <td><el-button type="text" size="mini" icon="el-icon-document" @click="goOrder(collectRecordData.orderid)">{{ collectRecordData.orderNum }}</el-button></td>
          <th>生产单号</th>
          <td>{{ collectRecordData.produnum }}</td>
          <th>终端地址</th>
          <td>{{ collectRecordData.address }}</td>
        </tr>
        <tr>
          <th>抵款日期</th>
          <td>{{ collectRecordData.receiptTime }}</td>
          <th>抵款金额</th>
          <td>
            <span style="color:#409EFF;font-weight: 500;margin-right: 6px;"><i class="el-icon-coin" /> {{ collectRecordData.money }}</span>
            <el-tag :disable-transitions="true" size="mini" type="danger">{{ creditPercentage }}%</el-tag>
          </td>
          <th>总金额</th>
          <td>
            <span style="margin-right: 6px;font-weight: 500;"><i class="el-icon-coin" /> {{ collectRecordData.totalamount }}</span>
            <el-tag v-if="collectRecordData.discount>0" :disable-transitions="true" size="mini" type="danger">{{ collectRecordData.discount }}折</el-tag>
            <el-tag v-if="collectRecordData.discount<=0" :disable-transitions="true" size="mini" type="info">0折</el-tag>
          </td>
        </tr>
        <tr>
          <th>收款性质</th>
          <td>
            <span>{{ typeList[collectRecordData.collectionType] }}</span>
          </td>
          <th>收款内容</th>
          <td colspan="3">{{ collectRecordData.content }}</td>
        </tr>
        <tr>
          <th>类型</th>
          <td v-if="viewAfterdata.type===0" colspan="5" style="color:#000;">售后赔款</td>
          <td v-if="viewAfterdata.type===1" colspan="5" style="color:#000;">划帐</td>
        </tr>
        <tr>
          <th>备注</th>
          <td colspan="5">{{ collectRecordData.remark }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="viewAfterVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 报备金抵扣详情 -->
    <el-dialog
      title="报备金抵扣详情"
      :visible.sync="viewReportVisible"
      width="50%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <table v-loading="viewReportLoading" class="tcf-detail-table">
        <tr>
          <th>审核人</th>
          <td>{{ viewReportdata.auditname }}</td>
          <th>审核时间</th>
          <td colspan="3">{{ viewReportdata.audittime }}</td>
        </tr>
        <tr>
          <th style="width: 100px">报备金名称</th>
          <td colspan="5" style="color:#000;">{{ viewReportdata.name }}</td>
        </tr>
        <tr>
          <th>报备要求</th>
          <td>
            {{ viewReportdata.per }}/单
          </td>
          <th>报备金额</th>
          <td style="font-weight: 500;"><i class="el-icon-coin" /> {{ viewReportdata.amount }}</td>
          <td colspan="2">
            同比享受最低折扣不低于 {{ viewReportdata.mindiscount }} 折
          </td>
        </tr>
        <tr>
          <th>终端地址</th>
          <td colspan="5">
            <table class="tcf-detail-table">
              <tr v-for="(d,index) in viewReportAddress" :key="index">
                <td style="width: 50px;text-align: center">{{ index+1 }}</td>
                <td>{{ d.address }}</td>
                <td>
                  <span v-if="d.orderid!==null&&d.orderid!==''&&d.orderid!==undefined" style="color:#409EFF;cursor: pointer" @click="goOrder(d.orderid)"><i class="el-icon-document" /> <span v-if="d.produnum===null||d.produnum===''||d.produnum===undefined">{{ d.ordernum }}</span><span v-if="d.produnum!==null&&d.produnum!==''&&d.produnum!==undefined">{{ d.produnum }}</span></span>
                  <el-tag v-if="d.orderid===null||d.orderid===''||d.orderid===undefined" :disable-transitions="true" size="mini" type="danger">未关联</el-tag>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <th>有效期</th>
          <td colspan="5">
            <span><i class="el-icon-date" /> {{ viewReportdata.starttime }} ~ {{ viewReportdata.endtime }}</span>
          </td>
        </tr>
        <tr>
          <th>对应折扣</th>
          <td colspan="5">
            <table class="tcf-detail-table">
              <tr v-for="(d,index) in viewReportDiscount" :key="index">
                <td style="width: 50px;text-align: center">{{ index+1 }}</td>
                <td>{{ d.starttime }} 至 {{ d.endtime }}</td>
                <td style="width: 100px;text-align: center">{{ d.discount }}折</td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <th>报备凭证</th>
          <td colspan="5">
            <el-image
              v-for="iurl in imgReportSrcList"
              :key="iurl"
              style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
              :src="iurl"
              :preview-src-list="imgReportSrcList"
            />
          </td>
        </tr>
        <tr>
          <th>报备说明</th>
          <td colspan="5">{{ viewReportdata.remark }}</td>
        </tr>
        <tr>
          <th>经销商</th>
          <td>{{ collectRecordData.dealerName }}</td>
          <th>操作人</th>
          <td>{{ collectRecordData.operName }}</td>
          <th>操作时间</th>
          <td colspan="3">{{ collectRecordData.crTime }}</td>
        </tr>
        <tr>
          <th>订单号</th>
          <td><el-button type="text" size="mini" icon="el-icon-document" @click="goOrder(collectRecordData.orderid)">{{ collectRecordData.orderNum }}</el-button></td>
          <th>生产单号</th>
          <td>{{ collectRecordData.produnum }}</td>
          <th>终端地址</th>
          <td>{{ collectRecordData.address }}</td>
        </tr>
        <tr>
          <th>抵款日期</th>
          <td>{{ collectRecordData.receiptTime }}</td>
          <th>抵款金额</th>
          <td>
            <span style="color:#409EFF;font-weight: 500;margin-right: 6px;"><i class="el-icon-coin" /> {{ collectRecordData.money }}</span>
            <el-tag :disable-transitions="true" size="mini" type="danger">{{ creditPercentage }}%</el-tag>
          </td>
          <th>总金额</th>
          <td>
            <span style="margin-right: 6px;font-weight: 500;"><i class="el-icon-coin" /> {{ collectRecordData.totalamount }}</span>
            <el-tag v-if="collectRecordData.discount>0" :disable-transitions="true" size="mini" type="danger">{{ collectRecordData.discount }}折</el-tag>
            <el-tag v-if="collectRecordData.discount<=0" :disable-transitions="true" size="mini" type="info">0折</el-tag>
          </td>
        </tr>
        <tr>
          <th>收款性质</th>
          <td>
            <span>{{ typeList[collectRecordData.collectionType] }}</span>
          </td>
          <th>收款内容</th>
          <td colspan="3">{{ collectRecordData.content }}</td>
        </tr>
        <tr>
          <th>备注</th>
          <td colspan="5">{{ collectRecordData.remark }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="viewReportVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 样品预存款抵扣详情 -->
    <el-dialog
      title="样品预存款抵扣详情"
      :visible.sync="jmDetailVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <table v-loading="jmFullscreenLoading" class="tcf-detail-table">
        <tr>
          <th>申请人</th>
          <td>{{ jmDetail.apply_name }}</td>
          <th>申请时间</th>
          <td colspan="3">{{ jmDetail.time }}</td>
        </tr>
        <tr>
          <th>招商总监</th>
          <td>{{ jmDetail.dirname }}</td>
          <th>审核时间</th>
          <td colspan="3">{{ jmDetail.dirtime }}</td>
        </tr>
        <tr>
          <th>财务审核</th>
          <td>{{ jmDetail.auditname }}</td>
          <th>审核时间</th>
          <td colspan="3">{{ jmDetail.audittime }}</td>
        </tr>
        <tr>
          <th>店面形式</th>
          <td>{{ jmDetail.shopform===1?'店中店':jmDetail.shopform===2?'沿街店':'商场内店' }}</td>
          <th>门店地址</th>
          <td colspan="3">{{ jmDetail.address }}</td>
        </tr>
        <tr>
          <th>总面积</th>
          <td>{{ jmDetail.totalarea }}</td>
          <th>本品牌占店面积</th>
          <td colspan="3">{{ jmDetail.area }}</td>
        </tr>
        <tr>
          <th>客户</th>
          <td><el-button type="text" size="small" icon="el-icon-s-custom">{{ jmDetail.all_name }}</el-button></td>
          <th>卡号</th>
          <td colspan="3">{{ jmDetail.card_num }}</td>
        </tr>
        <tr>
          <th>打款账户</th>
          <td colspan="5"><span v-for="av in jmDetail.accountVoList" v-if="av.is_select===1" :key="av">{{ av.account_name }}（{{ av.card }}）</span></td>
        </tr>
        <tr>
          <th>打款日期</th>
          <td>{{ jmDetail.pay_time }}</td>
          <th>打款金额</th>
          <td colspan="3">{{ jmDetail.pay_price }}（样品预存款：{{ jmDetail.joins }}，加盟费：{{ jmDetail.insure }}）</td>
        </tr>
        <tr>
          <th>打款凭证</th>
          <td colspan="5">
            <el-image
              v-for="iurl in jmImgSrcList"
              :key="iurl"
              style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
              :src="iurl"
              :preview-src-list="jmImgSrcList"
            />
          </td>
        </tr>
        <tr>
          <th>加盟备注</th>
          <td colspan="5">{{ jmDetail.remark }}</td>
        </tr>
        <tr>
          <th>经销商</th>
          <td>{{ collectRecordData.dealerName }}</td>
          <th>操作人</th>
          <td>{{ collectRecordData.operName }}</td>
          <th>操作时间</th>
          <td colspan="3">{{ collectRecordData.crTime }}</td>
        </tr>
        <tr>
          <th>订单号</th>
          <td><el-button type="text" size="mini" icon="el-icon-document" @click="goOrder(collectRecordData.orderid)">{{ collectRecordData.orderNum }}</el-button></td>
          <th>生产单号</th>
          <td>{{ collectRecordData.produnum }}</td>
          <th>终端地址</th>
          <td>{{ collectRecordData.address }}</td>
        </tr>
        <tr>
          <th>抵款日期</th>
          <td>{{ collectRecordData.receiptTime }}</td>
          <th>抵款金额</th>
          <td>
            <span style="color:#409EFF;font-weight: 500;margin-right: 6px;"><i class="el-icon-coin" /> {{ collectRecordData.money }}</span>
            <el-tag :disable-transitions="true" size="mini" type="danger">{{ creditPercentage }}%</el-tag>
          </td>
          <th>总金额</th>
          <td>
            <span style="margin-right: 6px;font-weight: 500;"><i class="el-icon-coin" /> {{ collectRecordData.totalamount }}</span>
            <el-tag v-if="collectRecordData.discount>0" :disable-transitions="true" size="mini" type="danger">{{ collectRecordData.discount }}折</el-tag>
            <el-tag v-if="collectRecordData.discount<=0" :disable-transitions="true" size="mini" type="info">0折</el-tag>
          </td>
        </tr>
        <tr>
          <th>收款性质</th>
          <td>
            <span>{{ typeList[collectRecordData.collectionType] }}</span>
          </td>
          <th>收款内容</th>
          <td colspan="3">{{ collectRecordData.content }}</td>
        </tr>
        <tr>
          <th>备注</th>
          <td colspan="5">{{ collectRecordData.remark }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="jmDetailVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getAccounts, getGroupReport } from '@/api/pub'
import { getMerchantsMoneyDetail } from '@/api/work'
import { getPaycontent, getDealerAccountRebateById, getDealerAccountAfterById, getDealerAccountReportById, getCollectionInfo, getCollectionStatement, excelCollectionStatement, printCollectionStatement } from '@/api/erp'
import { getLodop } from '@/common/Lodop/LodopFuncs'

export default {
  name: 'Ddskdzd',
  data() {
    return {
      typeList: {
        0: '账户抵扣',
        3: '对公打款',
        4: '收款抹零',
        5: '返点抵扣',
        6: '赔款抵扣',
        66: '划账抵扣',
        7: '报备金抵扣',
        8: '样品预存款抵扣'
      },
      orderTypeList: {
        0: '正单',
        1: '客改单',
        2: '增补单',
        3: '色板单',
        4: '售后单'
      },
      orderStatusList: {
        9: '预付款',
        10: '工厂分派',
        11: '等待工厂接单',
        12: '订单待排产',
        13: '订单生产中',
        100: '订单已完成'
      },
      paycontentList: [],
      groupList: [],
      accountsList: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      searchForm: {
        time: [],
        opertime: [],
        type: null,
        groupid: null,
        search: null,
        paycontent: null
      },
      tableData: [],
      loading: false,
      pringLoading: false,
      excelLoading: false,
      // 样品预存款抵扣详情
      jmFullscreenLoading: false,
      jmDetailVisible: false,
      jmDetail: [],
      jmImgSrcList: [],
      // 返点抵扣详情
      viewRebateLoading: false,
      viewRebateVisible: false,
      viewRebatedata: [],
      imgRebateSrcList: [],
      // 赔款抵扣详情
      viewAfterVisible: false,
      viewAfterLoading: false,
      viewAfterdata: [],
      imgAfterSrcList: [],
      // 报备金抵扣详情
      viewReportVisible: false,
      viewReportLoading: false,
      viewReportdata: [],
      imgReportSrcList: [],
      viewReportAddress: [],
      viewReportDiscount: [],
      viewReportAcccount: [],
      // 订单收款明细
      collectRecordVisible: false,
      collectRecordLoading: false,
      // 收款明细
      collectRecordData: [],
      // 抵扣百分比
      creditPercentage: null,
      // 对公打款详情
      editVisible: false,
      fullscreenLoading: false,
      eidtList: { ra: {}},
      editForm: {},
      imgSrcList: []
    }
  },
  computed: {
    user: getUser
  },
  created() {
    getGroupReport().then(response => {
      this.groupList = response.data
    }).catch(() => {})
    getAccounts().then(response => {
      this.accountsList = response.data
    }).catch(() => {})
    getPaycontent().then(response => {
      this.paycontentList = response.data
    }).catch(() => {})
    this.getData()
  },
  methods: {
    Search() {
      this.currentPage = 1
      this.getData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    getData() {
      this.loading = true
      let starttime = ''
      let endtime = ''
      if (this.searchForm.time !== null && this.searchForm.time !== undefined) {
        if (this.searchForm.time.length === 2) {
          starttime = this.searchForm.time[0]
          endtime = this.searchForm.time[1]
        }
      }
      let operstarttime = ''
      let operendtime = ''
      if (this.searchForm.opertime !== null && this.searchForm.opertime !== undefined) {
        if (this.searchForm.opertime.length === 2) {
          operstarttime = this.searchForm.opertime[0]
          operendtime = this.searchForm.opertime[1]
        }
      }
      const data = {
        type: this.searchForm.type,
        content: this.searchForm.search,
        paycontent: this.searchForm.paycontent,
        starttime: starttime,
        endtime: endtime,
        page: this.currentPage,
        limit: this.pageSize,
        groupid: this.user.dGroupid,
        operstarttime: operstarttime,
        operendtime: operendtime
      }
      getCollectionStatement(data).then(response => {
        this.tableData = response.data
        this.total = response.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    openDetails(row) {
      console.log(111)
      this.collectRecordData = row
      this.creditPercentage = (row.money / row.totalamount * 100).toFixed(2)
      if (row.collectionType === '3' && row.crid !== 0) { // 对公打款
        console.log(row)
        this.imgSrcList = []
        this.editVisible = true
        this.fullscreenLoading = true
        this.editForm.applyname = row.operName
        this.editForm.delname = row.dealerName
        getCollectionInfo({ userid: this.user.dUserid, crid: row.crid }).then(response => {
          this.eidtList = response.data
          const imgs = []
          for (const c of this.eidtList.applyInfo.imgs) {
            imgs.push(c.img_url)
          }
          this.imgSrcList = imgs
          this.fullscreenLoading = false
        }).catch(() => {
          this.fullscreenLoading = false
        })
      } else if (row.collectionType === '5' && row.dataid !== 0) { // 返点抵扣
        this.imgRebateSrcList = []
        this.viewRebateVisible = true
        this.viewRebateLoading = true
        getDealerAccountRebateById({ darid: row.dataid }).then(response => {
          this.viewRebateLoading = false
          this.viewRebatedata = response.data.dar
          const imgs = []
          for (const c of response.data.imgs) {
            imgs.push(c.img_url)
          }
          this.imgRebateSrcList = imgs
        }).catch(() => {
          this.viewRebateLoading = false
        })
      } else if ((row.collectionType === '6' || row.collectionType === '66') && row.dataid !== 0) { // 赔款抵扣 - 划账
        this.imgAfterSrcList = []
        this.viewAfterVisible = true
        this.viewAfterLoading = true
        getDealerAccountAfterById({ daaid: row.dataid }).then(response => {
          this.viewAfterLoading = false
          this.viewAfterdata = response.data.daa
          const imgs = []
          for (const c of response.data.imgs) {
            imgs.push(c.img_url)
          }
          this.imgAfterSrcList = imgs
        }).catch(() => {
          this.viewAfterLoading = false
        })
      } else if (row.collectionType === '7' && row.dataid !== 0) { // 报备金抵扣
        this.imgReportSrcList = []
        this.viewReportVisible = true
        this.viewReportLoading = true
        getDealerAccountReportById({ darid: row.dataid }).then(response => {
          this.viewReportLoading = false
          this.viewReportdata = response.data.dar
          this.viewReportAddress = response.data.daralst
          this.viewReportDiscount = response.data.dardlst
          this.viewReportAcccount = response.data.acccount
          const imgs = []
          for (const c of response.data.imgs) {
            imgs.push(c.img_url)
          }
          this.imgReportSrcList = imgs
        }).catch(() => {
          this.viewReportLoading = false
        })
      } else if (row.collectionType === '8' && row.joinid !== '0') { // 样品预存款抵扣
        this.jmImgSrcList = []
        this.jmDetailVisible = true
        this.jmFullscreenLoading = true
        getMerchantsMoneyDetail({ payid: row.joinid, userid: this.user.dUserid }).then(response => {
          this.jmFullscreenLoading = false
          this.jmDetail = response.data
          const imgs = []
          for (const c of this.jmDetail.imgList) {
            imgs.push(c.img_url)
          }
          this.jmImgSrcList = imgs
        }).catch(() => {
          this.jmFullscreenLoading = false
        })
      } else { // 余额抵扣
        this.collectRecordVisible = true
      }
    },
    goOrder(orderid) {
      this.collectRecordVisible = false
      this.receiptAccountVisible = false
      this.viewReportVisible = false
      this.$router.push({ path: '/work/order/' + orderid })
    },
    print() {
      const LODOP = getLodop()
      if (LODOP !== null && LODOP !== undefined) {
        if (!this.pringLoading) {
          let starttime = ''
          let endtime = ''
          if (this.searchForm.time !== null && this.searchForm.time !== undefined) {
            if (this.searchForm.time.length === 2) {
              starttime = this.searchForm.time[0]
              endtime = this.searchForm.time[1]
            }
          }
          if (this.total > 1000) {
            if (starttime === '' && endtime === '') {
              this.$message({
                message: '由于数据量过多，请进行筛选再打印',
                type: 'warning'
              })
              return false
            }
          }
          this.pringLoading = true
          const data = {
            type: this.searchForm.type,
            content: this.searchForm.search,
            starttime: starttime,
            endtime: endtime,
            groupid: this.user.dGroupid
          }
          printCollectionStatement(data).then(response => {
            this.pringLoading = false
            LODOP.PRINT_INIT('订单收款对账单打印')
            LODOP.SET_PRINT_PAGESIZE(2, 0, 0, 'A4')
            LODOP.SET_PRINT_MODE('PRINT_PAGE_PERCENT', 'Auto-Width')
            LODOP.ADD_PRINT_TABLE(30, 1, '100%', '100%', response.data)
            LODOP.SET_PRINT_STYLEA(0, 'HOrient', 3)
            LODOP.SET_PRINT_STYLEA(0, 'VOrient', 3)
            LODOP.SET_SHOW_MODE('LANDSCAPE_DEFROTATED', 1)
            LODOP.NewPageA()
            LODOP.SET_PRINT_STYLEA(0, 'HtmWaitMilSecs', 100)
            LODOP.PREVIEW()
          }).catch(() => {
            this.pringLoading = false
          })
        }
      }
    },
    exportExcel() {
      let starttime = ''
      let endtime = ''
      if (this.searchForm.time !== null && this.searchForm.time !== undefined) {
        if (this.searchForm.time.length === 2) {
          starttime = this.searchForm.time[0]
          endtime = this.searchForm.time[1]
        }
      }
      if (this.total > 1000) {
        if (starttime === '' && endtime === '') {
          this.$message({
            message: '由于数据量过多，请进行筛选再导出',
            type: 'warning'
          })
          return false
        }
      }
      this.$message({
        message: '数据正在导出，请稍候'
      })
      this.excelLoading = true
      const data = {
        type: this.searchForm.type,
        paycontent: this.searchForm.paycontent,
        content: this.searchForm.search,
        starttime: starttime,
        endtime: endtime,
        groupid: this.user.dGroupid
      }
      excelCollectionStatement(data).then(response => {
        const _this = this
        const xhr = new XMLHttpRequest()
        xhr.open('GET', response.data.dPath, true)
        xhr.responseType = 'blob'
        xhr.onload = function() {
          if (this.status === 200) {
            const blob = this.response
            const a = document.createElement('a')
            a.download = response.data.dName + '.' + response.data.dType
            a.href = window.URL.createObjectURL(blob)
            a.target = '_blank'
            a.click()
            _this.excelLoading = false
            const h = _this.$createElement
            _this.$msgbox({
              title: '下载提示',
              message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
                h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                h('a',
                  { attrs: {
                    href: window.URL.createObjectURL(blob),
                    target: '_blank',
                    download: `${response.data.dName}.${response.data.dType}`,
                    style: 'color: #409EFF;text-decoration:underline;'
                  }}, `点击这里`),
                h('span', null, `重新下载。`)
              ]),
              showCancelButton: false,
              confirmButtonText: '关闭',
              beforeClose: (action, instance, done) => {
                done()
              }
            }).then(action => {
            })
          }
        }
        xhr.send()
      }).catch(() => {
        this.excelLoading = false
      })
    }
  }
}
</script>

<style scoped>

</style>
